import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseId() {
  try {
    return Number(localStorage.getItem("sabi_empresa_id")) || 1;
  } catch {
    return 1;
  }
}

function getBranchId() {
  try {
    return Number(localStorage.getItem("sabi_sucursal_id")) || undefined;
  } catch {
    return undefined;
  }
}

function getLicenseName() {
  const keys = [
    "sabi_empresa_nombre",
    "empresa_nombre",
    "licenseName",
  ];

  for (const key of keys) {
    try {
      const value = localStorage.getItem(key);
      if (value && value.trim()) return value.trim();
    } catch {
      // ignore
    }
  }

  return "empresa";
}

function slugifyFileName(value) {
  return String(value || "empresa")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}

function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
}

function withContext(params = {}, options = {}) {
  const licenseId = params.licenseId || getLicenseId();
  const branchId = options.disableBranchFallback
    ? params.branchId
    : params.branchId || getBranchId();

  return {
    ...params,
    licenseId,
    ...(branchId ? { branchId } : {}),
  };
}

export const getAttendanceDailyBoard = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/daily-board${qs(withContext(params))}`,
    opts
  );
};

export const getAttendanceWeeklyTotals = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/weekly-totals${qs(withContext(params))}`,
    opts
  );
};

export const getAttendanceExportEmployees = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/export-employees${qs(withContext(params, { disableBranchFallback: true }))}`,
    opts
  );
};

export const exportAttendancePdf = async (params = {}, opts) => {
  const licenseId = Number(params.licenseId || getLicenseId());
  const licenseName = params.licenseName || getLicenseName();

  const query = {
    licenseId,
    licenseName,
    fromDate: params.fromDate,
    toDate: params.toDate,
    ...(params.branchIds ? { branchIds: params.branchIds } : {}),
    ...(params.areaIds ? { areaIds: params.areaIds } : {}),
    ...(params.employeeIds ? { employeeIds: params.employeeIds } : {}),
    ...(params.search?.trim() ? { search: params.search.trim() } : {}),
  };

  const blob = await httpClient.getBlob(
    `/hr/schedules-attendance/export-pdf${qs(query)}`,
    {
      ...(opts || {}),
      headers: {
        Accept: "application/pdf",
        ...((opts && opts.headers) || {}),
      },
    }
  );

  const safeLicenseName = slugifyFileName(licenseName);
  const fileName = `asistencia-${safeLicenseName}-${params.fromDate}-a-${params.toDate}.pdf`;

  downloadBlob(blob, fileName);

  return {
    ok: true,
    fileName,
  };
};

export const getAttendanceEmployeeStats30d = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/employee-stats-30d${qs(withContext(params))}`,
    opts
  );
};

export const getAttendanceEmployeeDayRecords = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/employee-day-records${qs(withContext(params))}`,
    opts
  );
};

export const getAttendanceEmployeeDayDetail = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/employee-day-detail${qs(
      withContext(params, { disableBranchFallback: true })
    )}`,
    opts
  );
};

export const saveAttendanceEmployeeDayDetail = async (data = {}, opts) => {
  return httpClient.post(
    "/hr/schedules-attendance/employee-day-detail",
    withContext(data, { disableBranchFallback: true }),
    opts
  );
};

export const deleteAttendanceEmployeeDayDetail = async (params = {}, opts) => {
  return httpClient.delete(
    `/hr/schedules-attendance/employee-day-detail${qs(
      withContext(params, { disableBranchFallback: true })
    )}`,
    opts
  );
};

export const deleteAttendanceEmployeeDaySession = async (sessionId, params = {}, opts) => {
  return httpClient.delete(
    `/hr/schedules-attendance/employee-day-detail/session/${sessionId}${qs(
      withContext(params, { disableBranchFallback: true })
    )}`,
    opts
  );
};

export const resolveAttendanceUnusualSession = async (sessionId, params = {}, opts) => {
  return httpClient.patch(
    `/hr/schedules-attendance/employee-day-detail/session/${sessionId}/resolve-unusual${qs(
      withContext(params, { disableBranchFallback: true })
    )}`,
    {},
    opts
  );
};

export const getAttendanceEmployeeMonthlySummary = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/schedules-attendance/employee-monthly-summary${qs(withContext(params))}`,
    opts
  );
};

export const getAttendanceBranches = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/employee-shifts/branches${qs({ licenseId: params.licenseId || getLicenseId() })}`,
    opts
  );
};

export const getAttendanceAreas = async (params = {}, opts) => {
  return httpClient.get(
    `/hr/employee-shifts/areas${qs({ licenseId: params.licenseId || getLicenseId() })}`,
    opts
  );
};
